// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://provider.qalbs.com/',
  reportServerUrl: 'https://provider.qalbs.com/',
  CORPORATE_PANEL_URL: "https://corporatedev.nemtsoftware.com/",
  TRACKING_URL: "https://membercare.nemtsoftware.com/trip-tracking/",
  UBER_AUTH_URL: "https://testuber.nemtplatform.com/",
  HMAC_APPLICATION_SECRET: '9Ptj-a6GITQI9-uG0w',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
